import { render, staticRenderFns } from "./LoginSignid.vue?vue&type=template&id=55f64f6b&scoped=true&"
import script from "./LoginSignid.vue?vue&type=script&lang=js&"
export * from "./LoginSignid.vue?vue&type=script&lang=js&"
import style0 from "./LoginSignid.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoginSignid.vue?vue&type=style&index=1&id=55f64f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f64f6b",
  null
  
)

export default component.exports